import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UploadService} from "../../core/services/upload.service";
import {environment} from "../../../environments/environment";
import {UtilityService} from "../../core/services/utility.service";
import {TYPE_INPUT} from "../../core/models/constants";

@Component({
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss']
})
export class InputFileComponent implements OnInit {
  @Input() accept: string = "image/png, image/jpg, image/jpeg, application/pdf";
  @Input() fileAttribute: any = {};
  @Input() labelText: string = "ADJUNTO";
  optionFile: any = {};
  optionFileList: any[] = [];

  CDN_BASE = environment.CDN_BASE;
  TYPE_INPUT = TYPE_INPUT;

  constructor(public uploadService: UploadService, private utilityService: UtilityService) {

    this.optionFileList.push({
      id: TYPE_INPUT.FILE,
      name: this.labelText
    });

    if(this.utilityService.isMobile()){
      this.optionFileList.push({
        id: TYPE_INPUT.FILE_CAMERA,
        name: "CAMARA"
      });
    }

    this.optionFile = this.optionFileList[0];

  }

  ngOnInit(): void {

  }

  selectOption(option: any){
    this.optionFile = option;
  }

}
